import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconTime: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.99935 1.66699C5.39667 1.66699 1.66602 5.39765 1.66602 10.0003C1.66602 14.603 5.39667 18.3337 9.99935 18.3337C14.602 18.3337 18.3327 14.603 18.3327 10.0003C18.3327 5.39765 14.602 1.66699 9.99935 1.66699ZM9.99935 2.91699C13.9117 2.91699 17.0827 6.088 17.0827 10.0003C17.0827 13.9126 13.9117 17.0837 9.99935 17.0837C6.08703 17.0837 2.91602 13.9126 2.91602 10.0003C2.91602 6.088 6.08703 2.91699 9.99935 2.91699ZM10.3366 6.45418C10.2953 6.14912 10.0338 5.91399 9.71735 5.91399C9.37217 5.91399 9.09235 6.19381 9.09235 6.53899V10.5782L9.09931 10.6713C9.12692 10.8547 9.23513 11.0183 9.39715 11.1149L12.5388 12.9891L12.6146 13.0276C12.8978 13.1484 13.2337 13.0443 13.3958 12.7725L13.4343 12.6968C13.5551 12.4136 13.4509 12.0777 13.1792 11.9156L10.342 10.2224L10.3423 6.53899L10.3366 6.45418Z"
        fill={fill || '#D0D0D1'}
      />
    </Icon>
  );
};

export default IconTime;
